import * as React from "react";
import { Input, Tooltip, Icon, Button, Divider, Upload, Checkbox } from "antd";
import { connect } from 'react-redux'

import { pushToast } from "../../stateManager/store/toast/actions";
import { logger } from "../../constant/winston";

type CommenScannerProps = {
  scannerData: string;
  handleDrawer?: any;
  ipc: any;
  pushToast: (data: any) => void;
};

type CommenScannerState = {
  phoneNumber: any;
  handleBtnLoading: boolean;
  isWebScanner: boolean;
};

class CommenScanner extends React.Component<
  CommenScannerProps,
  CommenScannerState
> {
  componentDidMount() {
    logger.debug(JSON.parse(atob(this.props.scannerData)));
  }
  componentWillUnmount() {
    this.setState({
      phoneNumber: null
    });
  }
  state = {
    phoneNumber: "",
    handleBtnLoading: false,
    isWebScanner: false
  };

  handlePhoneNumber = (e: any) => {
    this.setState({
      phoneNumber: e.target.value
    });
  };

  sendLink = async () => {
    this.props.pushToast(
      { type: 'error', message: 'Send link not for preview' }
    )
  };

  getMimeType = (filename: string): string => {
    const fileExtension = filename.split(".")[1];
    let mimetype = "";
    switch (fileExtension) {
      case "png":
        mimetype = "image/png";
        break;
      case "jpeg":
      case "jpg":
      case "jpe":
        mimetype = "image/jpeg";
        break;
      case "pdf":
        mimetype = "application/pdf";
        break;
      case "xlsb":
        mimetype = "application/xlsb";
        break;
      case "xltx":
        mimetype = "application/xltx";
        break;
      case "xltm":
        mimetype = "application/xltm";
        break;
      case "xls":
        mimetype = "application/xls";
        break;
      case "xlsx":
        mimetype = "application/xlsx";
        break;
      default:
        mimetype = "image/jpeg";
        break;
    }
    return mimetype;
  }

  handleUploadData = (file: any) => {
    // let { files } = file.target;
    const mimetype = this.getMimeType(file.name);
    let reader: any = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      // var { a8FlowInfo } = JSON.parse(atob(this.props.scannerData));
      // await axios.put(
      //   `${a8FlowInfo.url}process-instance/${a8FlowInfo.processInstanceId}/variables/${a8FlowInfo.imageVar}`,
      //   {
      //     value: reader.result.split("base64,")[1],
      //     type: "File",
      //     valueInfo: {
      //       filename: `${file.name}`,
      //       mimetype
      //     }
      //   },
      //   {
      //     headers: { Authorization: a8FlowInfo.authToken }
      //   }
      // );

      // let cloudImg = await axios.get(
      //   `${a8FlowInfo.url}process-instance/${a8FlowInfo.processInstanceId}/variables/${a8FlowInfo.imageVar}?deserializeValue=false`,
      //   {
      //     headers: { Authorization: a8FlowInfo.authToken }
      //   });

      var streamData = {
        variableValueInfo: {
          type: "File",
          value: reader.result,
          valueInfo: {
            filename: `${file.name}`,
            mimetype
          }
          // ...cloudImg.data
        },
        scannerData: JSON.parse(atob(this.props.scannerData))
      };


      this.props.ipc.contentWindow.postMessage(
        {
          formAction: "previewMannualUpdate",
          ...streamData
        },
        "*"
      );
      this.props.handleDrawer(false)
    };
  };

  render() {
    return (
      <div className="commenScannerWrapper">
        {/* <hr /> */}
        <div className="mobileNumberWrapper">
          <p className="scannerHeaderGeneral">
            Scan Your Document Via Android device
          </p>
          <Input
            data-test-id="phone_number_scan"
            className={"phoneNumberScan"}
            placeholder="Enter your mobile Number"
            prefix={<Icon type="mobile" style={{ color: "rgba(0,0,0,.25)" }} />}
            onChange={this.handlePhoneNumber}
            value={this.state.phoneNumber}
            // type="number"
            suffix={
              <Tooltip title="You will get the SMS about Scanning Process.">
                <Icon type="info-circle" style={{ color: "rgba(0,0,0,.45)" }} />
              </Tooltip>
            }
          />
          <div className="webScan">
            <Checkbox data-test-id="web_scanner_check" checked={this.state.isWebScanner} onChange={(e) => { this.setState({ isWebScanner: e.target.checked }); logger.debug(e.target.checked) }}>
              Use Web scanner
            </Checkbox>
          </div>
          <br />
          <Button
            data-test-id="send_link_btn"
            type="primary"
            htmlType="button"
            className={"sendLinkButton"}
            onClick={this.sendLink}
            loading={this.state.handleBtnLoading}
            style={{ marginTop: "10px" }}
          >
            Send Link
          </Button>
        </div>
        {JSON.parse(atob(this.props.scannerData)).docType !== "QR" &&
          JSON.parse(atob(this.props.scannerData)).a8FlowInfo.imageVar && (
            <React.Fragment>
              <Divider>or</Divider>
              <div className="fileUploader">
                <p className="scannerHeaderGeneral">Upload Your Document</p>
                {/* <span className="form-files-input scanner-form-file-input"> */}

                <Upload
                  data-test-id="test"
                  name="test"
                  customRequest={({ file, onSuccess }: any) => {
                    setTimeout(() => {
                      onSuccess("ok");
                    }, 0);
                  }}
                  showUploadList={false}
                  data={data => {
                    this.handleUploadData(data);
                  }}
                >
                  <Button
                    data-test-id="click_to_upload"
                    type="primary"
                    htmlType="button"
                    className={"normalUploadButton"}
                  >
                    <Icon type="upload" /> Click to Upload
                  </Button>
                </Upload>
              </div>
            </React.Fragment>
          )}
      </div>
    );
  }
}



export default connect(null, { pushToast })(CommenScanner);
